import { supabase } from "@/integrations/supabase/client";
import { Json } from "@/integrations/supabase/types";

export interface ProfileData {
  id: string;
  display_name: string | null;
  email: string | null;
  phone: string | null;
  avatar_url: string | null;
  bio: string | null;
  headline: string | null;
  about_me: string | null;
  pronouns: string | null;
  age: number | null;
  location: string | null;
  hobbies: string | null;
  timezone: string | null;
  language: string | null;
  created_at: string | null;
  followers_count: number | null;
  following_count: number | null;
  unlocked_features: Json | null;
}

// קבלת פרופיל משתמש
export const getProfile = async (userId: string): Promise<ProfileData | null> => {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();

  if (error) {
    console.error('Error fetching profile:', error);
    return null;
  }

  return data as ProfileData;
};

// עדכון פרופיל משתמש
export const updateProfile = async (
  userId: string,
  updates: Partial<ProfileData>
): Promise<boolean> => {
  const { error } = await supabase
    .from('profiles')
    .update(updates)
    .eq('id', userId);

  if (error) {
    console.error('Error updating profile:', error);
    return false;
  }

  return true;
};

// קבלת פוסטים של משתמש
export const getUserPosts = async (userId: string) => {
  const { data, error } = await supabase
    .from('community_posts')
    .select('*')
    .eq('author_id', userId)
    .eq('status', 'published')
    .order('created_at', { ascending: false })
    .limit(20);

  if (error) {
    console.error('Error fetching user posts:', error);
    return [];
  }

  return data;
};

// קבלת תגובות של משתמש
export const getUserComments = async (userId: string) => {
  const { data, error } = await supabase
    .from('community_comments')
    .select(`
      *,
      post:community_posts(id, title, content, challenge_id)
    `)
    .eq('author_id', userId)
    .order('created_at', { ascending: false })
    .limit(20);

  if (error) {
    console.error('Error fetching user comments:', error);
    return [];
  }

  return data;
};

// ספירת פעילות משתמש
export const getUserActivityStats = async (userId: string) => {
  const [postsResult, commentsResult, likesResult] = await Promise.all([
    supabase
      .from('community_posts')
      .select('id', { count: 'exact', head: true })
      .eq('author_id', userId),
    supabase
      .from('community_comments')
      .select('id', { count: 'exact', head: true })
      .eq('author_id', userId),
    supabase
      .from('community_likes')
      .select('id', { count: 'exact', head: true })
      .eq('user_id', userId)
  ]);

  return {
    postsCount: postsResult.count || 0,
    commentsCount: commentsResult.count || 0,
    likesGiven: likesResult.count || 0
  };
};
